module.exports = __webpack_public_path__ + "static/media/hk.e6b2ad32.svg";